<script setup>
const getSecondTitle = (data) => {
  return `${data?.title.split('/')[1]}, ${new Date(
    data?.date
  ).toLocaleDateString('uk-UA')}, `
}

defineProps({
  anime: {
    type: Object,
    default: () => {}
  }
})
</script>

<template>
  <h1
    class="bg-neutral/80 shadow-lg px-[12px] py-[16px] rounded-[12px] lg:rounded-t-[12px] lg:rounded-b-[0px] w-fit font-bold text-2xl"
  >
    {{ anime?.title }}
  </h1>
</template>
